module.exports = __webpack_public_path__ + "static/media/blue-down-arrow.b7822296.svg";